import React, { useEffect, useState } from 'react';
import axios from 'axios';
import moment from 'moment';
import CreateTask from '../TodoList/Modals/CreateTask';
import Card from '../TodoList/Card';
import '../Shared/Css/TodoList.css';
import { FaRegAddressCard, FaRegFileAlt } from 'react-icons/fa';
import { NavMenu } from './../NavMenu.js';

const TodoList = () => {
    //사번복고화시작
    const [pwloading, setPwLoading] = useState(0); //실행시 한번만 권한가지기
    const [urlpw, setUrlpw] = useState(0); //실행시 매번 권한가져오기
    //사번복고화종료
    const [taskRead, setTaskRead] = useState(false)
    const [modal, setModal] = useState(false)
    const [taskList, setTaskList] = useState([])

    //------------------------------------------------------세션복고화시작
    const pwBog = () => {
        const pwNo = parseInt(sessionStorage.getItem('100') - 660620); //사번복구화
        //console.log(pwNo);
        pwNo > 0 ? setPwLoading(pwNo) : setPwLoading();
    }

    const pwLogin = () => {
        const pwNoPlus = parseInt(sessionStorage.getItem('100') - 660620); //사번복구화
        setUrlpw(pwNoPlus)
    }
    //------------------------------------------------------세션복고화끝

    useEffect(() => {
        pwBog()
        pwLogin()
        if (pwloading !== urlpw) {
        //window.location.href = '/AcountLogin/Login';
        window.location.assign('/AcountLogin/Login/');
        }
    }, [pwloading, urlpw])


    const loadRead = () => {
        const sessionSabun = parseInt(sessionStorage.getItem('100') - 660620) // 저장된것 사번 가져오기
        const url = '/api/TaskList/';
        axios.get(url, { params: { sabun: sessionSabun } } )
          .then((res) => {
            setTaskList(res.data);
        })
    }

    useEffect(() => {
        loadRead()
        setTaskRead(false)
        // console.log("실행함")
      }, [taskRead])

    // useEffect(() => {
    //     let arr = localStorage.getItem("taskList")
    //     if (arr) {
    //         let obj = JSON.parse(arr)
    //         setTaskList(obj)
    //         console.log(obj);    
    //     }
    //     //console.log(arr);      
    // }, [])

    

    const deleteTask = (index) => {
        setTaskRead(true)
        // window.location.reload()
    }

    const updateListArray = (obj, index) => {
        const stringifyObj = JSON.stringify(obj);
        const parseObj = JSON.parse(stringifyObj);
        console.log(obj)
        const formData = new FormData();
        formData.append('id', parseObj.id); 
        formData.append('t_개인사번', parseObj.t_개인사번); 
        formData.append('t_할일제목', parseObj.t_할일제목);
        formData.append('t_할일내용', parseObj.t_할일내용);
        formData.append('t_등록일자', parseObj.t_등록일자);

        const url = '/api/TaskList/';
        axios.put(url + parseObj.id , formData, { headers })
        .then((res) => {
            //setTaskList(res.data);
            setTaskRead(true)
        })
        .catch(error => {
          console.log(error);
        })
        setTaskRead(true)
        // window.location.reload()
    }

    const toggle = () => {
        setModal(!modal);
    }

    const headers = () => {
        return {
          'Content-type': `text/plain`,
        };
      };

    const saveTask = (taskObj) => {
        const stringifyObj = JSON.stringify(taskObj);
        const parseObj = JSON.parse(stringifyObj);
        // console.log(`이곳: ${parseObj.t_할일내용}`);
        const formData = new FormData();
        formData.append('t_할일제목', parseObj.t_할일제목);
        formData.append('t_할일내용', parseObj.t_할일내용);
        formData.append('t_개인사번', urlpw);
        formData.append('t_등록일자', moment().format('YYYY-MM-DD HH:mm:ss'));

        const url = '/api/TaskList/';
        axios.post(url, formData, { headers })
        .then((res) => {
            setTaskRead(true)
        })
        .catch(error => {
          console.log(error);
        })
        setModal(false)
        // setTaskRead(true)
        window.location.reload()
    }

    // const saveTask = (taskObj) => {
    //     let tempList = taskList
    //     tempList.push(taskObj)
    //     localStorage.setItem("taskList", JSON.stringify(tempList))
    //     setTaskList(taskList)
    //     setModal(false)
    //     window.location.reload()
    // }


    return (
        <>
            <NavMenu></NavMenu>
            <div className="header text-center">
                <h3><FaRegAddressCard color='blue' fontSize={30} />개인[일정관리]리스트</h3>
                <button className="btn btn-primary mt-1" style={{width:'120px'}} onClick={() => setModal(true)}><FaRegFileAlt color='white' fontSize={18} /> 일정추가 </button>
                <button className="btn btn-info mt-1" style={{marginLeft:'5px', width:'120px'}} onClick={(e) => { window.location.href = `/MenuLink/MenuLink` }} ><FaRegFileAlt color='white' fontSize={18}/>나가기[MES]</button>
            </div>
            <div className="task-container">
                {taskList && taskList.map((obj, index) => <Card key={index} taskObj={obj} index={index} deleteTask={deleteTask} updateListArray={updateListArray} />)}
            </div>

            <CreateTask toggle={toggle} modal={modal} save={saveTask} />

        </>
    );
};

export default TodoList;